/* v8 ignore start */
import {LottieCompositionModel} from "@/lib/lottie/animation/lottieCompositionModel";
import {LottieImageLayerModel} from "@/lib/lottie/layers/lottieImageLayerModel";
import {LottieLayerModel} from "@/lib/lottie/layers/lottieLayerModel";
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieNullLayerModel} from "@/lib/lottie/layers/lottieNullLayerModel";
import {LottiePrecompositionLayerModel} from "@/lib/lottie/layers/lottiePrecompositionLayerModel";
import {LottieShapeLayerModel} from "@/lib/lottie/layers/lottieShapeLayerModel";
import {LottieSolidColorLayerModel} from "@/lib/lottie/layers/lottieSolidColorLayerModel";
import {LottieTextLayerModel} from "@/lib/lottie/layers/lottieTextLayerModel";

export type TLottieLayerModel = LottieLayerModel<LottieCompositionModel.TLayerType>;

export function lottieLayerModelResolver(json: LottieLayerModel.IJson): TLottieLayerModel {
  const type = json.ty;

  if (type === LottieLayerType.PreComposition) {
    return new LottiePrecompositionLayerModel(json as LottiePrecompositionLayerModel.IJson);
  } else if (type === LottieLayerType.Image) {
    return new LottieImageLayerModel(json as LottieImageLayerModel.IJson);
  } else if (type === LottieLayerType.SolidColor) {
    return new LottieSolidColorLayerModel(json as LottieSolidColorLayerModel.IJson);
  } else if (type === LottieLayerType.Text) {
    return new LottieTextLayerModel(json as LottieTextLayerModel.IJson);
  } else if (type === LottieLayerType.Null) {
    return new LottieNullLayerModel(json as LottieNullLayerModel.IJson);
  } else if (type === LottieLayerType.Shape) {
    return new LottieShapeLayerModel(json as LottieShapeLayerModel.IJson);
  } else {
    throw new Error(`Unsupported layer type: ${type}`);
  }
}
/* v8 ignore stop */
